import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@domain-group/fe-blueprint-ui/form';
import { srOnly } from '@domain-group/fe-brary';
import btoa from 'btoa-lite';

import * as styles from './fields.style';

export const toggleArrayItem = (array, item) => {
  const index = array.indexOf(item);
  if (array.includes(item)) {
    array.splice(index, 1); // remove if exists
  } else {
    array.push(item); // add if not
  }
  return array;
};

const CheckboxesField = ({
  fieldName,
  onBlur,
  onChange,
  options,
  selected = [],
  title,
  hiddenTitle,
  wrapperStyles,
  itemStyles,
}) => (
  <div
    role="group"
    aria-labelledby={`group_label_${btoa(title)}`}
    css={wrapperStyles}
  >
    <p id={`group_label_${btoa(title)}`} css={hiddenTitle ? srOnly : ''}>
      {title}
    </p>
    {options.map((option) => {
      const handleChange = (event) => {
        const newSelected = toggleArrayItem(
          selected,
          event.currentTarget.value,
        );
        onChange(fieldName, newSelected);
      };

      const handleBlur = () => {
        onBlur(fieldName, true);
      };

      const isSelected = selected.includes(option.value);

      return (
        <div css={[styles.checkboxField, itemStyles]} key={option.value}>
          <Checkbox
            name={fieldName}
            id={option.value}
            value={option.value}
            onChange={handleChange}
            onBlur={handleBlur}
            labelContent={option.label}
            checked={isSelected}
          />
        </div>
      );
    })}
  </div>
);

CheckboxesField.defaultProps = {
  selected: undefined,
  hiddenTitle: true,
  wrapperStyles: undefined,
  itemStyles: undefined,
};

CheckboxesField.propTypes = {
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selected: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  hiddenTitle: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  wrapperStyles: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  itemStyles: PropTypes.any,
};

export default CheckboxesField;
